import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=30e83e53&"
import script from "./NewsModal.vue?vue&type=script&lang=ts&"
export * from "./NewsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e83e53')) {
      api.createRecord('30e83e53', component.options)
    } else {
      api.reload('30e83e53', component.options)
    }
    module.hot.accept("./NewsModal.vue?vue&type=template&id=30e83e53&", function () {
      api.rerender('30e83e53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/components/NewsModal.vue"
export default component.exports